import { render, staticRenderFns } from "./AreaListItem.vue?vue&type=template&id=e9ae4250&scoped=true&"
import script from "./AreaListItem.vue?vue&type=script&lang=js&"
export * from "./AreaListItem.vue?vue&type=script&lang=js&"
import style0 from "./AreaListItem.vue?vue&type=style&index=0&id=e9ae4250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ae4250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VListItemContent,VListItemTitle,VTextarea})
